// Import the functions you need from the SDKs you need
// logEvent
import {getAnalytics, logEvent, setUserId, setUserProperties} from "firebase/analytics";
import {initializeApp} from "firebase/app";
import device from "current-device";
import i18next from 'i18next'
import { getUrlParams } from '@/utils/utils';


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAdpeJAaHJobMaWSLZDIaHExQ3HHXciclo",
  authDomain: "redotpay.firebaseapp.com", // for window auth test
  // authDomain: window.location.host,
  projectId: "redotpay",
  storageBucket: "redotpay.appspot.com",
  messagingSenderId: "136043112851",
  appId: "1:136043112851:web:3f00a4c56e353550b9a066",
};

export const analyticsFirebaseConfig = {
  apiKey: "AIzaSyCHo1IqN_pPu1kVhBvO6W4Y-t3xJJYY6Nc",
  authDomain: "redotpay-webapp.firebaseapp.com",
  // authDomain: window.location.host,
  projectId: "redotpay-webapp",
  storageBucket: "redotpay-webapp.firebasestorage.app",
  messagingSenderId: "158092143353",
  appId: "1:158092143353:web:a4f2ff72698e2c115bd028",
  measurementId: "G-R6Q328GYMJ"
}

export const startFirebaseAnalytics = () => {
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const analyticsApp = initializeApp(analyticsFirebaseConfig, 'analytics');
  window.fbApp = app;
  window.fbAnalytics = getAnalytics(analyticsApp);
  window.fbAnalytics2 = getAnalytics(app);

}

export const firebaseApp = initializeApp(firebaseConfig);

export const FB_EVENT_TYPES = {
  USER_PRE_REGISTER: 'rp_web_preregister',
  USER_LOGIN: 'rp_web_login',
  
  LOADED:"loaded",
  LOGIN_OR_REGISTER_CLICK:"login_or_register_click",
  USERNAME_INPUT:"username_input",
  CODE_INPUT:"code_input",
  GET_CODE_CLICK:"get_code_click",
  GET_CODE_SUCCESS:"get_code_success",
  // TERMS_CLICK:"terms_click", //跳走了先不加
  LOGIN_CLICK:"login_click",
  REGISTER_CLICK:"register_click",
  REGISTER_SUCCESS:"register_success",
  REGISTER_WITH_GOOGLE_CLICK:"register_with_google_click",
  REGISTER_WITH_GOOGLE_SUCCESS:"register_with_google_success",

}


export const fbLogEvent = (eventName, eventParams) => {
  if (window.fbAnalytics) {
    logEvent(window.fbAnalytics, eventName, eventParams);
  }
}

export const fbSetUserId = (uid) => {
  if (window.fbAnalytics) {
    setUserId(window.fbAnalytics, uid);
  }
}

export const fbSetUserProperties = (properties) => {
  if (properties instanceof Array) {
    properties.forEach(property => {
      fbSetUserProperty(property);
    });
  }
}

export const fbSetUserProperty = (property) => {
  if (!property || !property.name || !property.value) {
    return;
  }
  setUserProperties(window.fbAnalytics, {
    name: property.name,
    value: property.value,
  });
}


export const fbLogEventDefaultParams = (eventName, eventParams={}) => {
  if (window.fbAnalytics2) {
    const utm_id = getUrlParams("utm_id");
    const info = device.noConflict()
    const params = {
      ...eventParams,
      datetime: new Date().getTime(),
      lang: i18next.language,
      userAgent: navigator.userAgent,
      device:{os:info.os,orientation:info.orientation,type:info.type}
    };
    if (utm_id) {
      const utm_source = getUrlParams("utm_source");
      const utm_uid = getUrlParams("utm_uid");
      const utm_s = getUrlParams("utm_s");

      params.utmId = utm_id; 
      params.utmSource = utm_source;
      params.utmUid = utm_uid;
      params.utmS = utm_s;
    }

    const suffix="h5";
    // console.log(`${suffix}_${eventName}`,params);
    logEvent(window.fbAnalytics2, `${suffix}_${eventName}`, );
  }
}
